<template>
  <el-dialog
      :visible.sync="visible"
      title="采购合同下载"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
  >
    <el-form
        :model="dataForm"
        ref="dataForm"
        label-width="140px"
    >
      <el-form-item label-width="0">
        <tool-tip style="width: 500px">注意：合同基础信息以选择的第一行为准。请不要跨工厂下载加工合同。</tool-tip>
      </el-form-item>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="乙方联系人及电话：" prop="sellMan">
            <el-input v-model="dataForm.sellMan" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="乙方地址：" prop="sellAddress">
            <el-input v-model="dataForm.sellAddress" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="购货方(甲方)：" prop="buyCompanyName">
            <el-input v-model="dataForm.buyCompanyName" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="交货期：" prop="deadline">
            <el-date-picker
                v-model="dataForm.deadline"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                placeholder="选择船日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="收货说明：" prop="buyAddress">
        <el-input v-model="dataForm.buyAddress" placeholder="" type="textarea"
                  :rows="6"></el-input>
      </el-form-item>
      <el-form-item label="其他质量条款：" prop="other1">
        <el-input
            v-model="dataForm.other1"
            placeholder="其他质量条款"
            type="textarea"
            :rows="6"
        ></el-input>
      </el-form-item>
      <el-form-item label="违约责任条款：" prop="other2">
        <el-input
            v-model="dataForm.other2"
            placeholder="违约责任条款"
            type="textarea"
            :rows="6"
        ></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">下载合同
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import qs from 'qs'
import Cookies from 'js-cookie'

export default {
  data () {
    return {
      ids: '',
      visible: false,
      dataForm: {
        id: '',
        remark: '',
        name: '',
        type: '',
      },
    }
  },
  methods: {
    //导出采购合同
    exportFile () {
      var params = qs.stringify({
        token: Cookies.get('token'),
        ids: this.ids,
      })
      let downUrl = `${window.SITE_CONFIG['apiURL']}/trade/factorymake/export/file?${params}`
      window.open(downUrl, '_blank')
    },
    reset () {
      this.dataForm = {}
      if (this.$refs['dataForm']) {
        this.$refs['dataForm'].resetFields()
      }
    },
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.reset()
        this.getInfo()
      })
    },
    getInfo () {
      let idArr = this.ids.split(',')
      this.$http
          .get(`/trade/factorymake/${idArr[0]}`)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return this.$message.error(res.msg)
            }

            let exData = {}
            if (res.data && res.data.exportData) {
              exData = JSON.parse(res.data.exportData)
            }
            this.dataForm = {
              ...exData,
              id: res.data.id
            }
          })
          .catch((e) => {
            console.log(e)
          })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }
            let postForm = {
              ids: this.ids,
              exportData: JSON.stringify(this.dataForm)
            }
            this.$http.post(
                '/trade/factorymake/export/data',
                postForm
            )
                .then(({ data: res }) => {
                  if (res.code !== 0) {
                    return this.$message.error(res.msg)
                  }
                  this.exportFile()
                })
                .catch((e) => {
                  console.log(e)
                })
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
  },
}
</script>
